import {combineReducers} from "redux";

import ajouterDemandeFichierReducer from "./ajouterDemandeFichier";

export default combineReducers({
    ajouterDemandeFichier: ajouterDemandeFichierReducer
});